
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { MaturityScoreResult } from '@/types/assessment';
import { getMaturityLevelColor, getMaturityLevelDescription } from '@/utils/maturityLevelUtils';

interface MaturityScoreCardProps {
  title: string;
  maturityResult: MaturityScoreResult;
  description?: string;
  className?: string;
}

const MaturityScoreCard = ({ 
  title, 
  maturityResult, 
  description,
  className 
}: MaturityScoreCardProps) => {
  const { score, level, label } = maturityResult;
  const bgColor = getMaturityLevelColor(level);
  
  // Format score to display properly, ensuring we handle 0 correctly
  const displayScore = Number.isFinite(score) ? score.toFixed(1) : '0.0';
  
  return (
    <Card className={`overflow-hidden ${className}`}>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">{title}</CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="grid grid-cols-2 gap-4">
          <div className="flex flex-col">
            <span className="text-3xl font-bold">{displayScore}</span>
            <span className="text-sm text-muted-foreground">Score (0-4)</span>
          </div>
          <div 
            className={`flex flex-col items-center justify-center rounded-md p-3 ${level === 1 ? 'text-black' : 'text-white'}`}
            style={{ backgroundColor: bgColor }}
          >
            <span className="text-3xl font-bold">{level}</span>
            <span className="text-sm font-medium">{label}</span>
          </div>
        </div>
        <p className="mt-4 text-sm text-muted-foreground">
          {getMaturityLevelDescription(level)}
        </p>
      </CardContent>
    </Card>
  );
};

export default MaturityScoreCard;
